import React from "react";
import styles from "./styles.module.scss";
import ModalLayout from "../Layouts/ModalLayout/ModalLayout";
import pro_trial_success_image from "app/images/pro-trial-success-image.png";
import checkmark from "app/images/checkmark-green.svg";
import { useTranslation } from "react-i18next";
import ButtonVariant from "../Button/ButtonVariant";

interface IProps {
  isOpen: boolean;
  closeHandler: () => void;
}

const ProTrialSuccessModal = ({ isOpen, closeHandler }: IProps) => {
  const { t } = useTranslation();

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={closeHandler}
      classNames={styles.modal_container}
    >
      <div className={styles.modal_header_container}>
        <img
          src={pro_trial_success_image}
          alt="trial-success"
          className={styles.trial_img}
        />
        <div className={styles.trial_status_container}>
          <img src={checkmark} alt="checkmark" />
          <p className={styles.trial_status}>{t("Free Trial Confirmed!")}</p>
        </div>
      </div>
      <div className={styles.modal_body}>
        <h2 className={styles.modal_body_title}>
          {t("Welcome to CoachNow PRO")}
        </h2>
        <p className={styles.modal_body_description}>
          {t(
            "Video Analysis, Communication, and Powerful Automation. CoachNow has everything you need to get the job done.",
          )}
        </p>
        <span className={styles.button_wrapper}>
          <ButtonVariant
            buttonType="primary"
            title={"Get Started"}
            buttonStyles={styles.start_btn}
            onClickFunc={closeHandler}
          />
        </span>
      </div>
    </ModalLayout>
  );
};

export default ProTrialSuccessModal;
